const theme = {
  '--gray-color': '#E3F2FD',
  '--orange-color': '#044478',
  '--orange-hover-color': '#1565C0',
  '--orange-datepicker-selection-color': '#42A5F5',
  '--blue-color': '#1976D2',
  '--white-color': '#FFFFFF',
  '--black-color': '#000000',
  '--navtext-color': '#FFFFFF',
  '--header-color': '#1565C0',
};

export default theme;